// src/utils/PublicOnlyRoute.tsx
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import type { RootState } from "@state/store";

export const PublicOnlyRoute = () => {
  const token = useSelector((state: RootState) => state.user.token) || localStorage.getItem("token");

  // If already logged in, redirect to home
  return token ? <Navigate to="/" replace /> : <Outlet />;
};
